import { render, staticRenderFns } from "./Ranking2.vue?vue&type=template&id=05e30864&scoped=true"
import script from "./Ranking2.vue?vue&type=script&lang=js"
export * from "./Ranking2.vue?vue&type=script&lang=js"
import style0 from "./Ranking2.vue?vue&type=style&index=0&id=05e30864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e30864",
  null
  
)

export default component.exports